import { useCallback, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useBlocker } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import _ from 'lodash';
import NgpTwoButtonDialog from '../dialog-two-button/NgpTwoButtonDialog';
import { removeEmptyValues } from '../../utilities/FormUtilities';

export const useStyles = makeStyles(() => ({
    formConfirmDiv: {
        minWidth: 325,
    },
}));

export const dirtyFormTitleText = i18n._(t`Discard Changes?`);
export const dirtyFormConfirmText = i18n._(t`Discard Changes`);
export const dirtyFormCancelText = i18n._(t`Stay Here`);
export const dirtyFormBodyText = i18n._(t`Your changes have not been saved.`);

function FormConfirm({ isDirtyFunc, excludeFromDirtyCheck }) {
    const { formState } = useFormContext();
    const { isDirty, dirtyFields, isSubmitted, isSubmitting } = formState;
    const [displayPrompt, setDisplayPrompt] = useState(false);
    const classes = useStyles();
    const retryFn = useRef({
        retry: _.noop,
    });

    const handleBlockNavigation = useCallback(
        ({ retry }) => {
            retryFn.current.retry = retry;
            setDisplayPrompt(true);
        },
        [retryFn]
    );

    const isFormDirty = useCallback(() => {
        if (isDirtyFunc && _.isFunction(isDirtyFunc)) {
            return isDirtyFunc(isDirty);
        }

        if (_.isArray(excludeFromDirtyCheck) && !_.isEmpty(excludeFromDirtyCheck)) {
            return isDirty && !_.isEmpty(removeEmptyValues(_.omit(dirtyFields, excludeFromDirtyCheck)));
        }

        return isDirty;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDirty, isDirtyFunc]);

    useBlocker(handleBlockNavigation, !isSubmitting && !isSubmitted && isFormDirty());

    return (
        <NgpTwoButtonDialog
            title={dirtyFormTitleText}
            confirmButtonText={dirtyFormConfirmText}
            cancelButtonText={dirtyFormCancelText}
            open={displayPrompt}
            setOpen={setDisplayPrompt}
            onConfirm={() => retryFn.current.retry()}
            isWarning
            disableBackdropClick
            closeInTitleBar={false}
        >
            <div className={classes.formConfirmDiv}>{dirtyFormBodyText}</div>
        </NgpTwoButtonDialog>
    );
}

export default FormConfirm;
